import { createSlice } from "@reduxjs/toolkit";
import { fetchInventoryPurchaseOrderReceivedPO } from "./thunk";

interface initialStateType {
  inventoryPurchaseOrderList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: initialStateType = {
  inventoryPurchaseOrderList: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const InventoryPurchaseOrderSlice = createSlice({
  name: "InventoryPurchaseOrder",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInventoryPurchaseOrderReceivedPO.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchInventoryPurchaseOrderReceivedPO.fulfilled,
        (state, action) => {
          state.loading = false;
          state.inventoryPurchaseOrderList = action.payload.data;
          state.rowCount = action.payload.rowCount;
        }
      )
      .addCase(
        fetchInventoryPurchaseOrderReceivedPO.rejected,
        (state, action) => {
          state.loading = false;
          state.error =
            action.error.message || "Failed to fetch Purchase Order List";
        }
      )
      // .addCase(fetchInventoryPurchaseOrderGRN.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      // })
      // .addCase(fetchInventoryPurchaseOrderGRN.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.inventoryPurchaseOrderList = action.payload.data;
      //   state.rowCount = action.payload.rowCount;
      // })
      // .addCase(fetchInventoryPurchaseOrderGRN.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error =
      //     action.error.message || "Network Error";
      // });
  },
});

export default InventoryPurchaseOrderSlice.reducer;
